import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsMouse: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11.43 16.76v1.53h6.09v-1.53h1.53v1.53h6.09v-1.53h1.53v10.67h1.52V10.67h-1.52V9.15h-1.53V7.62h-1.52V6.1h-4.57V3.05h-1.53V6.1h-4.57v1.52h-1.52v1.53H9.9v1.52H8.38v16.76H9.9V16.76ZM16 9.15h1.52V7.62h1.53v1.53h1.52v3.04h-1.52v1.53h-1.53v-1.53H16Zm9.14 18.28h1.53v1.53h-1.53Z\"/><path fill=\"currentColor\" d=\"M23.62 22.86h1.52v3.05h-1.52Zm-1.53 6.1h3.05v1.52h-3.05Zm0-3.05h1.53v1.52h-1.53Zm-3.04 1.52h3.04v1.53h-3.04Zm-4.58 3.05h7.62V32h-7.62Zm0-28.95h3.05v1.52h-3.05Zm-3.04 27.43h3.04v1.52h-3.04Zm0-25.91h3.04v1.52h-3.04ZM9.9 27.43h1.53v1.53H9.9Zm0-22.86h1.53V6.1H9.9ZM5.33 6.1H9.9v1.52H5.33ZM6.86 0h1.52v1.53H6.86ZM5.33 1.53h1.53v1.52H5.33ZM3.81 3.05h1.52V6.1H3.81Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsMouse
